// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 12px; /* Standard-Textgröße anpassen */
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

label {
  font-size: 18px; /* Schriftgröße für alle Label-Elemente anpassen */
}

.k-input {
  font-size: 18px; /* Schriftgröße für Eingabefelder */
}

.k-dropdownlist {
  font-size: 18px; /* Schriftgröße für Dropdown-Listen */
}

.k-list-item {
  font-size: 18px; /* Schriftgröße für Listenelemente im Dropdown */
}

.k-list {
  display: flex;
  flex-direction: column;
  padding: 0; /* Entfernt unerwünschte Abstände */
  margin: 0;  /* Entfernt unerwünschte Abstände */
}

:root {
  --kendo-color-primary: #ff8200;
  --kendo-color-primary-hover: #98a4ae;
  --kendo-color-primary-active: #98a4ae;
  --kendo-color-primary-emphasis: #98a4ae;
  --kendo-color-primary-on-subtle: #5c201c;
}

.custom-card {
  border: 2px solid #ff8008; /* Rahmenfarbe für Karten */
}

.custom-card-header {
  border-bottom: 1px solid #212934; /* Anpassung der Trennlinie im Header */
}

.custom-radio .k-radio-item {
  display: flex;
  align-items: center;
}

.custom-radio .k-radio-label {
  font-size: 18px; /* Schriftgröße des Labels */
  margin-left: 8px; /* Abstand zwischen Button und Label */
  margin-top: -2.5px; /* Abstand zwischen Button und Label */
}

.custom-radio .k-radio {
  transform: scale(1.2); /* Größe des Radio Buttons anpassen */
}


.custom-step {
  width: 60px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ff8008; /* Rahmenfarbe für Schritte */
  box-sizing: border-box;
}

.custom-stepper .k-step {
  width: 60px; /* Breite der Kreise */
  height: 60px; /* Höhe der Kreise */
  line-height: 20px; /* Text vertikal zentrieren */
  font-size: 15px; /* Schriftgröße im Kreis */
}

.custom-stepper .k-step .k-step-indicator {
  width: 45px; /* Breite des Indikators im Kreis */
  height: 45px; /* Höhe des Indikators im Kreis */
}

.custom-stepper .k-progressbar {
  height: 2px; /* Dicke der Linie */
  top: 25px; /* Positionierung der Linie */
}

.custom-stepper .k-progressbar .k-selected {
  background-color: #ff8008; /* Farbe der Linie für ausgewählte Schritte */
}

.custom-stepper .k-step-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-stepper .k-step-link .k-step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-stepper .k-step.k-state-selected .k-step-indicator {
  background-color: #98a4ae !important; /* Grau für den aktiven Schritt */
  color: #ffffff !important; /* Textfarbe für den aktiven Schritt */
  border-color: #98a4ae !important; /* Rahmenfarbe für den aktiven Schritt */
}

.custom-stepper .k-step.k-state-selected .k-step-label .k-step-text {
  color: #ffffff !important; /* Textfarbe für das Label des aktiven Schritts */
}

.custom-stepper .k-step .k-step-indicator {
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.custom-stepper .k-step .k-step-label .k-step-text {
  transition: color 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,eAAe,EAAE,gCAAgC;AACnD;;AAEA;EACE;aACW;AACb;;AAEA;EACE,eAAe,EAAE,kDAAkD;AACrE;;AAEA;EACE,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,eAAe,EAAE,qCAAqC;AACxD;;AAEA;EACE,eAAe,EAAE,gDAAgD;AACnE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU,EAAE,mCAAmC;EAC/C,SAAS,GAAG,mCAAmC;AACjD;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,gCAAgC,EAAE,uCAAuC;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,4BAA4B;EAC7C,gBAAgB,EAAE,sCAAsC;EACxD,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,qBAAqB,EAAE,qCAAqC;AAC9D;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAE,6BAA6B;EACxD,sBAAsB;AACxB;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,oBAAoB;EAClC,iBAAiB,EAAE,6BAA6B;EAChD,eAAe,EAAE,0BAA0B;AAC7C;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,YAAY,EAAE,iCAAiC;AACjD;;AAEA;EACE,WAAW,EAAE,oBAAoB;EACjC,SAAS,EAAE,6BAA6B;AAC1C;;AAEA;EACE,yBAAyB,EAAE,6CAA6C;AAC1E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC,EAAE,iCAAiC;EACvE,yBAAyB,EAAE,sCAAsC;EACjE,gCAAgC,EAAE,wCAAwC;AAC5E;;AAEA;EACE,yBAAyB,EAAE,iDAAiD;AAC9E;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 12px; /* Standard-Textgröße anpassen */\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nlabel {\n  font-size: 18px; /* Schriftgröße für alle Label-Elemente anpassen */\n}\n\n.k-input {\n  font-size: 18px; /* Schriftgröße für Eingabefelder */\n}\n\n.k-dropdownlist {\n  font-size: 18px; /* Schriftgröße für Dropdown-Listen */\n}\n\n.k-list-item {\n  font-size: 18px; /* Schriftgröße für Listenelemente im Dropdown */\n}\n\n.k-list {\n  display: flex;\n  flex-direction: column;\n  padding: 0; /* Entfernt unerwünschte Abstände */\n  margin: 0;  /* Entfernt unerwünschte Abstände */\n}\n\n:root {\n  --kendo-color-primary: #ff8200;\n  --kendo-color-primary-hover: #98a4ae;\n  --kendo-color-primary-active: #98a4ae;\n  --kendo-color-primary-emphasis: #98a4ae;\n  --kendo-color-primary-on-subtle: #5c201c;\n}\n\n.custom-card {\n  border: 2px solid #ff8008; /* Rahmenfarbe für Karten */\n}\n\n.custom-card-header {\n  border-bottom: 1px solid #212934; /* Anpassung der Trennlinie im Header */\n}\n\n.custom-radio .k-radio-item {\n  display: flex;\n  align-items: center;\n}\n\n.custom-radio .k-radio-label {\n  font-size: 18px; /* Schriftgröße des Labels */\n  margin-left: 8px; /* Abstand zwischen Button und Label */\n  margin-top: -2.5px; /* Abstand zwischen Button und Label */\n}\n\n.custom-radio .k-radio {\n  transform: scale(1.2); /* Größe des Radio Buttons anpassen */\n}\n\n\n.custom-step {\n  width: 60px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #ff8008; /* Rahmenfarbe für Schritte */\n  box-sizing: border-box;\n}\n\n.custom-stepper .k-step {\n  width: 60px; /* Breite der Kreise */\n  height: 60px; /* Höhe der Kreise */\n  line-height: 20px; /* Text vertikal zentrieren */\n  font-size: 15px; /* Schriftgröße im Kreis */\n}\n\n.custom-stepper .k-step .k-step-indicator {\n  width: 45px; /* Breite des Indikators im Kreis */\n  height: 45px; /* Höhe des Indikators im Kreis */\n}\n\n.custom-stepper .k-progressbar {\n  height: 2px; /* Dicke der Linie */\n  top: 25px; /* Positionierung der Linie */\n}\n\n.custom-stepper .k-progressbar .k-selected {\n  background-color: #ff8008; /* Farbe der Linie für ausgewählte Schritte */\n}\n\n.custom-stepper .k-step-link {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-stepper .k-step-link .k-step-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-stepper .k-step.k-state-selected .k-step-indicator {\n  background-color: #98a4ae !important; /* Grau für den aktiven Schritt */\n  color: #ffffff !important; /* Textfarbe für den aktiven Schritt */\n  border-color: #98a4ae !important; /* Rahmenfarbe für den aktiven Schritt */\n}\n\n.custom-stepper .k-step.k-state-selected .k-step-label .k-step-text {\n  color: #ffffff !important; /* Textfarbe für das Label des aktiven Schritts */\n}\n\n.custom-stepper .k-step .k-step-indicator {\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.custom-stepper .k-step .k-step-label .k-step-text {\n  transition: color 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
